import type { PracticaDefinition, ProjectDefinition } from "../types";
import { funcionesCategorias } from "./funciones";
import { practicas } from "./projects";

/** Every practice the add-in knows about, including ones not on the home list. */
export const allPracticas: PracticaDefinition[] = [
  ...practicas,
  ...funcionesCategorias,
];

export function findPractica(
  id: string | null | undefined
): PracticaDefinition | undefined {
  if (!id) return undefined;
  return allPracticas.find((item) => item.id === id);
}

/** Function categories reuse the practice pages; their ids share this prefix. */
export function isFuncionCategoria(id: string | null | undefined): boolean {
  return !!id && id.startsWith("funciones-");
}

export function findProjectInfo(
  projectId: string
): { practica: PracticaDefinition; project: ProjectDefinition } | null {
  for (const practica of allPracticas) {
    const project = practica.projects.find((p) => p.id === projectId);
    if (project) return { practica, project };
  }
  return null;
}
